module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/hair-dryer-88d0fb76bed0391aee2acb624be79aae.svg";